//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import constants from '~/constants';
import utils from '~/utils';

export default {
  name: 'Story',

  data() {
    return {
      CDN: process.env.CDN,
      activeIndex: 0,
      // settings for swiper
      swiperOption: {
        touchEventsTarget: 'wrapper',
        spaceBetween: 15,
        speed: 400,
        navigation: true,
        resizeObserver: true,
        lazy: {
          loadPrevNext: true,
        },
        slidesPerView: 'auto',
        breakpoints: {
          751: {
            slidesPerView: 6,
            spaceBetween: 20,
          },
        },
        on: {
          activeIndexChange: (swiper) => {
            this.activeIndex = swiper.activeIndex;
          },
        },
      },
    };
  },

  computed: {
    ...mapState(['features', 'isMobile']),
  },

  mounted() {
    this.$nextTick(() => {
      this.handleResize();
    });
    window.addEventListener('resize', this.handleResize);
  },

  methods: {
    handleBtnPrevClick() {
      this.$swiper.slidePrev();
    },
    handleBtnNextClick() {
      this.$swiper.slideNext();
    },
    handleResize() {
      if (this.$swiper && this.$swiper.params) {
        const ratio = utils.calcRatio();
        const spaceBetween = this.isMobile ? 15 : 20;

        this.$swiper.params.spaceBetween = spaceBetween * ratio;
      }
    },
    isDisable(story) {
      return story.status === constants.STATUS__COMING_SOON;
    },
  },
};
